export default __webpack_public_path__ + "static/4-bd31e1df9a906b82f0ea9e0c3f082039.jpg";